var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('FooterBar'),_c('HeaderBar'),_c('RightMenu'),_c('ApplyDialog'),_c('ContactDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }